import React, { useEffect, useState } from 'react';
import { schedulingAPI, browserTz, fmtSlot } from '../../lib/schedulingApi';
import SlotPicker from './SlotPicker';

export default function DirectSlots({ poolId, duration, panel, excludeId, value, onChange, who, setWho }) {
  const [slots, setSlots] = useState(null);
  const tz = browserTz();
  useEffect(() => {
    if (!poolId) return;
    setSlots(null);
    onChange(null);
    schedulingAPI.poolSlots(poolId, { duration, days: 21, panel, ...(excludeId ? { exclude: excludeId } : {}) })
      .then(({ data }) => setSlots(data)).catch(() => setSlots([]));
  }, [poolId, duration, panel, excludeId]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div data-testid="direct-slots" style={{ minWidth: 0 }}>
      <div className="iv-small" style={{ marginBottom: '0.4rem' }}>Times shown in your timezone ({tz}). Only times when enough pool members are free are listed.</div>
      <SlotPicker slots={slots} tz={tz} value={value?.start} onChange={(s) => { onChange(s); setWho(''); }} showFree emptyText="Nobody in this pool is free in the next 3 weeks. Check their hours on the Availability tab." />
      {value && (
        <div className="iv-row" style={{ marginTop: '0.75rem' }}>
          <span className="iv-small" data-testid="direct-selected-slot"><b>{fmtSlot(value.start, tz)}</b></span>
          {panel === 1 && (
            <select className="iv-select" style={{ maxWidth: 260 }} value={who} onChange={(e) => setWho(e.target.value)} data-testid="direct-interviewer-select">
              <option value="">Auto-assign (fair share)</option>
              {value.free.map((m) => <option key={m.id} value={m.id}>{m.name || 'Interviewer'}</option>)}
            </select>
          )}
        </div>
      )}
    </div>
  );
}
